export default "__VITE_ASSET__BMr5$9XM__"